import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Script from "next/script.js";
export default function GA4({ measurementId }) {
    return (_jsxs(_Fragment, { children: [_jsx(Script, { src: `https://www.googletagmanager.com/gtag/js?id=${measurementId}`, strategy: "afterInteractive" }), _jsx(Script, { strategy: "afterInteractive", children: `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());

				gtag('config', '${measurementId}');
			` })] }));
}
